import { FC } from 'react';
import ErrorMessage from './ErrorMessage';

type Props = {
  reset: () => void;
};

const Error: FC<Props> = ({ reset }) => {
  return (
    <div className="flex justify-center items-center h-full">
      <ErrorMessage />
    </div>
  );
};

export default Error;
